export default function EmptyState({ title = 'No data yet', message = 'Upload a report to populate this page.' }) {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      <p>{message}</p>
    </div>
  );
}
